import React from 'react';
import styled from "styled-components";

const CloseIcon: React.FC = () => (
    <Icon
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <path
        d="M9.49922 16.8997C5.18622 16.8997 1.68984 13.4033 1.68984 9.09028C1.68984 4.77728 5.18622 1.28091 9.49922 1.28091C13.8122 1.28091 17.3086 4.77728 17.3086 9.09028C17.3086 13.4033 13.8122 16.8997 9.49922 16.8997ZM9.49922 18.0153C14.4284 18.0153 18.4242 14.0194 18.4242 9.09028C18.4242 4.16114 14.4284 0.165283 9.49922 0.165283C4.57008 0.165283 0.574219 4.16114 0.574219 9.09028C0.574219 14.0194 4.57008 18.0153 9.49922 18.0153Z"
        fill="white"
    />
    <path
        d="M5.75791 5.34898C5.97575 5.13114 6.32894 5.13114 6.54678 5.34898L9.49922 8.30142L12.4517 5.34898C12.6695 5.13114 13.0227 5.13114 13.2405 5.34898C13.4584 5.56681 13.4584 5.92 13.2405 6.13784L10.2881 9.09028L13.2405 12.0427C13.4584 12.2606 13.4584 12.6138 13.2405 12.8316C13.0227 13.0494 12.6695 13.0494 12.4517 12.8316L9.49922 9.87915L6.54678 12.8316C6.32894 13.0494 5.97575 13.0494 5.75791 12.8316C5.54007 12.6138 5.54007 12.2606 5.75791 12.0427L8.71035 9.09028L5.75791 6.13784C5.54007 5.92 5.54007 5.56681 5.75791 5.34898Z"
        fill="white"
    />
</Icon>
);

const Icon = styled.svg`
   &:hover{
       transform: scale(1.2);
   }
`
export default CloseIcon;